(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@braindate/util/lib/assert"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@braindate/util/lib/assert"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assert);
    global.eventSponsorAssertions = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _assert) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.assertEventSponsor = assertEventSponsor;
  _exports.assertEventSponsorLogo = assertEventSponsorLogo;
  _exports.assertEventSponsorPlugin = assertEventSponsorPlugin;

  /**
   * Throw an exception if parameter is not an object
   * @param   {any} value - Value to check
   * @returns {undefined}
   */
  function assertEventSponsor(value) {
    (0, _assert.assertObject)(value, "sponsor");
  }

  /**
   * Throw an exception if parameter is not an object
   * @param   {any} value - Value to check
   * @returns {undefined}
   */
  function assertEventSponsorLogo(value) {
    (0, _assert.assertObject)(value, "event.logo");
  }

  /**
   * Throw an exception if parameter is not an object
   * @param   {any} value - Value to check
   * @returns {undefined}
   */
  function assertEventSponsorPlugin(value) {
    (0, _assert.assertObject)(value, "sponsor");
  }
});